import { ProductActivationType } from 'src/constants';

export enum ActionPageType {
  UpgradeAccount,
  CreatePayment,
  Ewallet,
}

export type StatusProduct = {
  type: ProductActivationType;
  enabled: boolean;
};

export const DEFAULT_ACTIVE_PRODUCT: StatusProduct[] = [
  {
    type: ProductActivationType.Shopee,
    enabled: false,
  },
  {
    type: ProductActivationType.DANA,
    enabled: false,
  },
  {
    type: ProductActivationType.QRIS,
    enabled: false,
  },
  {
    type: ProductActivationType.LinkAja,
    enabled: false,
  },
];

export const AmplitudeActionPage: Record<ActionPageType, string> = {
  [ActionPageType.UpgradeAccount]: 'upgrade_account',
  [ActionPageType.Ewallet]: 'ewallet',
  [ActionPageType.CreatePayment]: 'create_payment_checkout_link',
};
